function getTitle(vm) {
    const {docTitle} = vm.$options
    if (docTitle) {
        if (typeof(docTitle) === 'function') {
            return docTitle.call(vm)
        } else {
            return docTitle;
        }
    }
}

export default {
    created() {
        const title = getTitle(this);
        if (title) {
            document.title = title;
        }
    }
}